// npm i @aws-sdk/client-rekognition
import {
  GetFaceLivenessSessionResultsCommand,
  DetectFacesCommand,
  DetectLabelsCommand,
  DetectProtectiveEquipmentCommand
} from "@aws-sdk/client-rekognition";
import { createRekognitionClient } from "../credentials/awsClients";

const rek = createRekognitionClient();

const BLOCK_LABELS = new Set([
  "Sunglasses","Glasses","Goggles",
  "Mask","Face Mask","Medical Mask",
  "Hat","Cap","Helmet","Hood","Balaclava","Scarf",
  "Headphones","Ear Protection", "bonnet"
]);

export async function evaluateLivenessAndAccessories(sessionId) {
  const liveRes = await rek.send(
    new GetFaceLivenessSessionResultsCommand({ SessionId: sessionId })
  );

  const livenessScore = liveRes.Confidence ?? 0;

  const ref = liveRes.ReferenceImage;
  const audit = liveRes.AuditImages?.[0];
  const img = ref || audit;

  if (!img) {
    return { livenessScore, passed: false, reasons: ["NoImageFromLiveness"] };
  }

  const faces = await rek.send(new DetectFacesCommand({
    Image: img,
    Attributes: ["ALL"]
  }));

  const flags = [];
  const f0 = faces.FaceDetails?.[0];
  if (f0?.Sunglasses?.Value && (f0.Sunglasses.Confidence ?? 0) >= 80) {
    flags.push({ type: "Sunglasses", source: "DetectFaces", confidence: f0.Sunglasses.Confidence });
  }
  if (f0?.Eyeglasses?.Value && (f0.Eyeglasses.Confidence ?? 0) >= 85) {
    flags.push({ type: "Glasses", source: "DetectFaces", confidence: f0.Eyeglasses.Confidence });
  }
  if (f0?.Occluded?.Value && (f0.Occluded.Confidence ?? 0) >= 80) {
    flags.push({ type: "FaceOccluded", source: "DetectFaces", confidence: f0.Occluded.Confidence });
  }

  const labels = await rek.send(new DetectLabelsCommand({
    Image: img,
    MinConfidence: 80
  }));
  for (const l of labels.Labels ?? []) {
    if (BLOCK_LABELS.has(l.Name ?? "")) {
      flags.push({ type: l.Name, source: "DetectLabels", confidence: l.Confidence ?? 0 });
    }
    for (const inst of l.Instances ?? []) {
      if ((l.Name && BLOCK_LABELS.has(l.Name)) && (inst.Confidence ?? 0) >= 80) {
        flags.push({ type: l.Name, source: "DetectLabels", confidence: inst.Confidence });
      }
    }
  }

  const ppe = await rek.send(new DetectProtectiveEquipmentCommand({
    Image: img,
    SummarizationAttributes: {
      MinConfidence: 80,
      RequiredEquipmentTypes: ["FACE_COVER", "HEAD_COVER"]
    }
  }));
  for (const p of ppe.Persons ?? []) {
    for (const item of p.BodyParts ?? []) {
      for (const eq of item.EquipmentDetections ?? []) {
        const kind = eq.Type;
        const conf = eq.Confidence ?? 0;
        if (conf >= 80) {
          flags.push({ type: kind, source: "PPE", confidence: conf });
        }
      }
    }
  }

  const ACCESSORIES_BLOCK = flags.length > 0;
  const passed = livenessScore >= 95 && !ACCESSORIES_BLOCK;

  return {
    livenessScore,
    passed,
    accessories: flags.sort((a,b)=> b.confidence - a.confidence)
  };
}
